import { WebSocketClient } from './websocketclient'
import { SetLogout } from './util'

let userWS = null

export function connectUserWebSocket(id) {
  if (!id) {
    if (userWS) {
      userWS.close()
    }
    return
  }
  if (id && userWS) {
    return
  }
  userWS = new WebSocketClient(
    `${process.env.VUE_APP_WS_URL}/web/ws/user/${encodeURIComponent(id)}`,
    {
      onOpen: () => console.log('✅ Connected'),
      onMessage: data => {
        if (data === 'LOGOUT') {
          console.log('收到实时退出指令')
          SetLogout()
        }
      },
      onClose: () => console.log('❌ Closed'),
      onError: e => console.error('⚠️ Error', e)
    }
  )
  userWS.connect()
}
